import { Mail, MapPin, Phone } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function Contact() {
    const [ref, visible] = useReveal();
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="relative py-20 sm:py-28 lg:py-36 border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} grid lg:grid-cols-12 gap-10`}>
                    <div className="lg:col-span-6">
                        <span className="section-tag">Contact · 05</span>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white mt-5 leading-tight">
                            Let&apos;s talk freight, before it costs you more.
                        </h2>
                        <p className="text-zinc-400 mt-5 leading-relaxed max-w-lg">
                            Have a specific challenge — rising surcharges, invoice disputes,
                            poor carrier performance, a tender coming up? Drop us a line. No
                            sales pitch, just a real conversation about what you&apos;re seeing.
                        </p>
                    </div>

                    <div className="lg:col-span-6 grid sm:grid-cols-2 gap-4">
                        <ContactCard
                            icon={<Mail size={18} />}
                            label="Email"
                            value="hello@wedelvrlogistics.com.au"
                            href="mailto:hello@wedelvrlogistics.com.au"
                            testid="contact-card-email"
                        />
                        <ContactCard
                            icon={<Phone size={18} />}
                            label="Phone"
                            value="Available on request"
                            testid="contact-card-phone"
                        />
                        <ContactCard
                            icon={<MapPin size={18} />}
                            label="Based in"
                            value="Australia · serving AU importers & exporters"
                            full
                            testid="contact-card-location"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}

function ContactCard({ icon, label, value, href, full, testid }) {
    const Comp = href ? "a" : "div";
    return (
        <Comp
            href={href}
            data-testid={testid}
            className={`card-glow rounded-xl p-5 sm:p-6 flex flex-col gap-3 ${
                full ? "sm:col-span-2" : ""
            }`}
        >
            <div
                className="w-9 h-9 rounded-md flex items-center justify-center"
                style={{
                    background: "rgba(0,240,255,0.08)",
                    border: "1px solid rgba(0,240,255,0.25)",
                    color: "#7DF9FF",
                }}
            >
                {icon}
            </div>
            <div>
                <div className="text-xs font-mono-accent text-zinc-500 uppercase tracking-[0.2em]">
                    {label}
                </div>
                <div className="font-display text-xl text-white mt-1">{value}</div>
            </div>
        </Comp>
    );
}
